(() => {
  const selectors = [
    '#shopify-chat',
    '#ShopifyChat',
    '#ShopifyInbox',
    '[data-shopify-chat]',
    'iframe[title*="Shopify Inbox" i]',
    'iframe[title*="Chat with us" i]',
    'iframe[src*="shopify-chat" i]',
    'iframe[src*="/inbox/" i]'
  ];

  const hideInbox = () => {
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  };

  hideInbox();
  new MutationObserver(hideInbox).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  window.addEventListener('load', hideInbox, { once: true });
})();